import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type PanelProps = {
  label?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  /** Removes body padding — for tables and lists that manage their own. */
  flush?: boolean;
};

export function Panel({
  label,
  actions,
  children,
  className,
  bodyClassName,
  flush = false,
}: PanelProps) {
  return (
    <section
      className={cn(
        'flex min-h-0 flex-col border border-line bg-panel/85 backdrop-blur-[1px]',
        className,
      )}
    >
      {(label || actions) && (
        <header className="flex h-9 shrink-0 items-center justify-between gap-3 border-b border-line bg-panel-alt px-3">
          {label ? <span className="label-xs text-ink-dim">{label}</span> : <span />}
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </header>
      )}
      <div className={cn('min-h-0 flex-1', flush ? '' : 'p-3', bodyClassName)}>{children}</div>
    </section>
  );
}
